import {
  IconPaperBag,
  IconSoup,
  IconToolsKitchen3,
} from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import type { PanelNavigationLink } from "@/features/panel/types";
import {
  getLocaleForPathname,
  getPathname,
  type LocalizedRoute,
} from "@/i18n/navigation";

const ICON_STROKE_WIDTH = 1.5;
const ICON_CLASS_NAME = "size-6 shrink-0";

export const getMobileMenuLinks = (): PanelNavigationLink[] => {
  const t = useTranslations();
  const locale = getLocaleForPathname();

  return [
    {
      href: getPathname({
        href: { pathname: "/diets/[[...slug]]", params: { slug: [] } },
        locale,
      }) as LocalizedRoute,
      icon: (
        <IconToolsKitchen3
          className={ICON_CLASS_NAME}
          strokeWidth={ICON_STROKE_WIDTH}
        />
      ),
      label: t("navigation.diets"),
      testData: "mobile-menu-diets",
    },
    {
      href: "/caterings",
      icon: (
        <IconPaperBag
          className={ICON_CLASS_NAME}
          strokeWidth={ICON_STROKE_WIDTH}
        />
      ),
      label: t("header.caterings"),
      testData: "mobile-menu-caterings",
    },
    {
      href: "/multidiet",
      icon: (
        <IconSoup className={ICON_CLASS_NAME} strokeWidth={ICON_STROKE_WIDTH} />
      ),
      label: t("header.menu.multidiet"),
      testData: "mobile-menu-multidiet",
    },
  ];
};
